module.exports = __webpack_public_path__ + "static/media/1.9ddc0298.svg";